import React, { useState } from 'react'
import { ChatWindow } from './chatWindow'
import { getRocketChatPinnedMessages, getRocketChatThreadMessages } from '../../../../api'
import { ThreadsSection } from '../threadsSecton/threadsSection'
import { SearchSection } from '../searchSection'
import { Modal } from 'antd'
import styled from 'styled-components'

const ModalBody = styled.div`
    background: #fff;
    border-radius: 12px;
    padding-bottom: 0px !important;
    .ant-modal-content {
         padding-bottom: 0px !important;
    }
    .modal-header {
        font-size: 15px;
        font-weight: 600;
        color: #29303e;
        margin: 10px 0px 18px;
        letter-spacing: 0.5px;
        text-align: left;
        border-bottom: 1px solid #f0f2f5;
        padding-bottom: 10px;
    }
    .message {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .message-avatar {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 12px;
            background: #f0f2f5;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .message-text {
            font-size: 13px;
            color: #29303e;
            font-weight: 500;
        }
    }
`

export const ChatSection = ({ channels, selectedChannel, containerRef, messages,
    threads, unredId, setSelectedThread, clientId, personId, firstUnreadRef, setThreads,
    threadsRef, ws, currentMessageRef, selectedThreadRef, loading, setShowParentThreads, selectedThread,
    showParentThreads, receipt, readReceipt, setReadReceipt, setMessages, markThreadRead,
    showPinnedMessages, setShowPinnedMessages, syncThreadsCount, fetchAllThreads, allParentThreads,
    loadingParentThreads, showParentThreadsRef, userAvatars, showSearchSection, setShowSearchSection, loadingNext,
    selectedMessageId, setSelectedMessageId, fetchAroundMessages, loadingPrev, userRole, showChannelMembers,
    setShowChannelMembers, draftMessage
}) => {

    const [loadngThreadReplies, setLoadingThreadReplies] = useState(false)
    const [pinnedMessages, setPinnedMessages] = useState([])
    const [loadingPinnedMessages, setLoadingPinnedMessages] = useState(false)

    const onClickViewAllThreads = () => {
        setShowPinnedMessages(false)
        setShowSearchSection(false)
        setShowParentThreads(true)
        showParentThreadsRef.current = true
        fetchAllThreads()
    }

    const fetchThreadMessages = async (id) => {
        setLoadingThreadReplies(true)
        const res = await getRocketChatThreadMessages({
            personId: personId,
            threadId: id
        })
        if (res['messages']) {
            setThreads(res.messages)
            threadsRef.current = res.messages
        }
        setLoadingThreadReplies(false)
    }

    const onClickViewThread = (msg) => {
        setShowSearchSection(false)
        setShowPinnedMessages(false)
        const newReadReceipt = readReceipt.map((receipt) => {
            if (receipt.rid === selectedChannel && receipt.tunread) {
                return {
                    ...receipt,
                    tunread: receipt.tunread.filter(id => id !== msg._id)
                }
            }
            return receipt
        })
        setReadReceipt(newReadReceipt)
        setSelectedThread(msg)
        selectedThreadRef.current = msg
        markThreadRead(msg._id)
    }

    const onClickShowPinnedMessages = async () => {
        setShowParentThreads(false)
        showParentThreadsRef.current = false
        setSelectedThread(null)
        setShowSearchSection(false)
        setShowPinnedMessages(true)
        setLoadingPinnedMessages(true)
        const pinnedMessagesRes = await getRocketChatPinnedMessages({
            personId: personId,
            roomId: selectedChannel
        })
        if (pinnedMessagesRes['messages']) setPinnedMessages(pinnedMessagesRes['messages'])
        setLoadingPinnedMessages(false)
    }

    const onClickShowSearchSection = () => {
        setShowParentThreads(false)
        showParentThreadsRef.current = false
        setSelectedThread(null)
        setShowPinnedMessages(false)
        setShowSearchSection(true)
    }

    return (
        <>
            <div className='right-container'>
                <ChatWindow
                    channels={channels}
                    selectedChannel={selectedChannel}
                    containerRef={containerRef}
                    messages={messages.filter((msg) => (!msg.t || msg.t !== 'au') && !msg.tmid && (msg.t !== 'message_pinned'))}
                    unredId={unredId}
                    threads={threads}
                    setSelectedThread={setSelectedThread}
                    clientId={clientId}
                    personId={personId}
                    firstUnreadRef={firstUnreadRef}
                    setThreads={setThreads}
                    threadsRef={threadsRef}
                    ws={ws}
                    currentMessageRef={currentMessageRef}
                    selectedThreadRef={selectedThreadRef}
                    loading={loading}
                    loadingNext={loadingNext}
                    loadingPrev={loadingPrev}
                    onClickViewAllThreads={onClickViewAllThreads}
                    receipt={receipt}
                    fetchThreadMessages={fetchThreadMessages}
                    loadngThreadReplies={loadngThreadReplies}
                    onClickViewThread={onClickViewThread}
                    showPinnedMessages={showPinnedMessages}
                    setShowPinnedMessages={setShowPinnedMessages}
                    setMessages={setMessages}
                    onClickShowPinnedMessages={onClickShowPinnedMessages}
                    syncThreadsCount={syncThreadsCount}
                    userAvatars={userAvatars}
                    setShowSearchSection={setShowSearchSection}
                    selectedMessageId={selectedMessageId}
                    userRole={userRole}
                    setShowChannelMembers={setShowChannelMembers}
                    onClickShowSearchSection={onClickShowSearchSection}
                    draftMessage={draftMessage}
                />
            </div>
            {(selectedThread) ? (
                <div className='rightmost-container right-container'>
                    <ChatWindow
                        channels={channels}
                        selectedChannel={selectedChannel}
                        containerRef={containerRef}
                        messages={threads ? [selectedThread, ...threads] : []}
                        unredId={unredId}
                        threads={threads}
                        setSelectedThread={setSelectedThread}
                        clientId={clientId}
                        personId={personId}
                        isThreadsWindow={true}
                        selectedThread={selectedThread}
                        firstUnreadRef={firstUnreadRef}
                        setThreads={setThreads}
                        threadsRef={threadsRef}
                        ws={ws}
                        currentMessageRef={currentMessageRef}
                        selectedThreadRef={selectedThreadRef}
                        loading={loading}
                        loadingNext={loadingNext}
                        loadingPrev={loadingPrev}
                        onClickViewAllThreads={onClickViewAllThreads}
                        receipt={receipt}
                        fetchThreadMessages={fetchThreadMessages}
                        loadngThreadReplies={loadngThreadReplies}
                        onClickViewThread={onClickViewThread}
                        showPinnedMessages={showPinnedMessages}
                        setShowPinnedMessages={setShowPinnedMessages}
                        setMessages={setMessages}
                        syncThreadsCount={syncThreadsCount}
                        userAvatars={userAvatars}
                        selectedMessageId={selectedMessageId}
                    />
                </div>
            ) : (showParentThreads ? (
                <div className='rightmost-container right-container'>
                    <ThreadsSection
                        list={allParentThreads}
                        containerRef={containerRef}
                        loading={loadingParentThreads}
                        setShowParentThreads={setShowParentThreads}
                        showParentThreadsRef={showParentThreadsRef}
                        fetchThreadMessages={fetchThreadMessages}
                        setSelectedThread={setSelectedThread}
                        receipt={receipt}
                        onClickViewThread={onClickViewThread}
                        selectedThreadRef={selectedThreadRef}
                        userAvatars={userAvatars}
                    />
                </div>
            ) : (<></>))}
            {showPinnedMessages && !selectedThread ? (
                <div className='rightmost-container right-container'>
                    <ThreadsSection
                        list={pinnedMessages}
                        containerRef={containerRef}
                        loading={loadingPinnedMessages}
                        setShowParentThreads={setShowPinnedMessages}
                        showParentThreadsRef={showParentThreadsRef}
                        fetchThreadMessages={fetchThreadMessages}
                        setSelectedThread={setSelectedThread}
                        receipt={receipt}
                        onClickViewThread={onClickViewThread}
                        selectedThreadRef={selectedThreadRef}
                        isPinnedMessagesSection={true}
                        userAvatars={userAvatars}
                    />
                </div>
            ) : (<></>)}
            {(showSearchSection && !selectedThread && !showPinnedMessages) ? (
                <div className='rightmost-container right-container'>
                    <SearchSection
                        setShowSearchSection={setShowSearchSection}
                        userAvatars={userAvatars}
                        selectedChannel={selectedChannel}
                        personId={personId}
                        setSelectedThread={setSelectedThread}
                        setSelectedMessageId={setSelectedMessageId}
                        messages={messages}
                        fetchAroundMessages={fetchAroundMessages}
                        setMessages={setMessages}
                    />
                </div>
            ) : (<></>)}
            <Modal
                open={showChannelMembers}
                width={'320px'}
                onCancel={() => setShowChannelMembers(false)}
                footer={null}
            >
                <ModalBody>
                    <div className="modal-header">Channel Members</div>
                    {selectedChannel && channels.filter(c => c._id === selectedChannel)[0].users.filter(user => user.username !== 'Akash_0').map((user) => {
                        const userAvatar = userAvatars.find(ua => ua.username === user.username)
                        return (
                            <div className='message'>
                                <div className='message-avatar'>
                                    {userAvatar['avatar'] ? <img src={userAvatar.avatar} alt={'profile'} /> :
                                        (<img src={`data:image/svg+xml;utf8,
                                    <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64'>
                                    <text x='50%' y='50%' font-size='48' text-anchor='middle' 
                                    dominant-baseline='middle' font-family='Gilroy'>
                                    ${user.username ? user.username.charAt(0) : ''} 
                                    </text>
                                    </svg>`} alt={'profile'} />)
                                    }
                                </div>
                                <div className='message-text'>
                                    {user.name}
                                </div>
                            </div>
                        )
                    })}
                </ModalBody>
            </Modal>
        </>
    )
}
